// Main logger composable - uses console transport by default
import { useLoggerConsole } from './logger/useLoggerConsole'

// Singleton instance using console transport
const logger = useLoggerConsole()

export function useLogger() {
  return {
    log: (component: string, event: string, data?: any) => logger.log(component, event, data),
    warn: (component: string, event: string, data?: any) => logger.warn(component, event, data),
    error: (component: string, event: string, data?: any) => logger.error(component, event, data),
    debug: (component: string, event: string, data?: any) => logger.debug(component, event, data),
    getLogs: () => logger.getLogs(),
    clearLogs: () => logger.clearLogs(),
    getLogsByComponent: (component: string) => logger.getLogsByComponent(component),
    getLogsByLevel: (level: 'info' | 'warn' | 'error' | 'debug') => logger.getLogsByLevel(level)
  }
}

// Export the logger instance for direct access if needed
export { logger }
